import { generateStripeState } from "../helper"

const options = {
  api: {
    list: ({ customer }) => `/api/stripe/customer/${customer}/paymentMethods`,
    delete: ({ customer, id }) => `/api/stripe/customer/${customer}/paymentMethod/${id}`,
    update: ({ customer, id }) => `/api/stripe/customer/${customer}/paymentMethod/${id}`,
    create: ({ customer, }) => `/api/stripe/customer/${customer}/paymentMethod`,
    get: ({ customer, id }) => `/api/stripe/customer/${customer}/paymentMethod/${id}`,
  },
  state: {
    collectionName: 'customerPaymentMethods'
  },
  getters: {
    getPagination: 'getCustomerPaymentMethodsPagination',
    getCollection: 'getCustomerPaymentMethods'
  },
  actions: {
    list: 'listCustomerPaymentMethods',
    update: 'updateCustomerPaymentMethod',
    create: 'createCustomerPaymentMethod',
    delete: 'deleteCustomerPaymentMethod',
    get: 'getCustomerPaymentMethod',
  },
  mutationKey: 'PAYMENT_METHODS',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)

export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  mutations: {
    ...stripeMutations
  },
  actions: {
    ...stripeActions
  }
}
